<template>
    <div class="outer">
        <div class="topSearch">
            <el-form class="queryRow" inline>
                <el-form-item label="入库单号" class="inNo">
                    <el-input v-model="queryForm.inNo" @change="onSearch" placeholder="请输入" clearable @clear="onSearch">
                    </el-input>
                </el-form-item>
                <el-form-item label="入库来源" prop="inSource">
                    <el-select style="width: 100%" v-model="queryForm.inSource" @change="onSearch" clearable @clear="onSearch" placeholder="请选择">
                        <el-option label="正常采购" :value="1"></el-option>
                        <el-option label="客户赠送" :value="2"></el-option>
                        <el-option label="私人库" :value="3"></el-option>
                        <el-option label="固定资产归还" :value="4"></el-option>
                        <el-option label="存量货物" :value="5"></el-option>
                        <el-option label="充值卡" :value="6"></el-option>
                        <el-option label="其他" :value="9"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="创建(入库)时间" prop="rqScopeArr">
                    <el-date-picker v-model="queryForm.rqScopeArr" type="daterange" value-format="yyyy-MM-dd"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable @change="onSearch"
                        @clear="onSearch">
                    </el-date-picker>
                </el-form-item>
                <el-form-item class="queryCol">
                    <el-button type="primary" icon="el-icon-search" @click="onSearch">
                        搜索
                    </el-button>
                </el-form-item>
            </el-form>
        </div>

        <el-table v-loading="loading" border class="table" :row-style="{ height: '50px' }"
            style="width: 100%;height: 68vh;overflow: auto;" :data="tableData">
            <template slot="empty">
                <el-empty :image-size="150"></el-empty>
            </template>
            <el-table-column align="center" label="入库单号" prop="inNo">
            </el-table-column>
            <el-table-column align="center" label="入库来源" prop="inSourceName">
            </el-table-column>
            <el-table-column align="center" label="货物名称" prop="goodsName">
            </el-table-column>
            <el-table-column align="center" label="数量" prop="goodsNum">
            </el-table-column>
            <el-table-column align="center" label="价格(元)" prop="price">
            </el-table-column>
            <el-table-column align="center" label="采购单号" prop="purchaseNo">
                <template slot-scope="scope">
                    <el-button type="text" @click="goPurchaseList(scope.row.purchaseNo)" v-if="scope.row.purchaseNo">{{ scope.row.purchaseNo }}</el-button>
                    <span v-else>--</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="提供人" prop="providerUserName">
            </el-table-column>
            <el-table-column align="center" label="创建人" prop="createUserName">
            </el-table-column>
            <el-table-column align="center" label="创建时间" prop="createTime" min-width="130" :formatter="dateTimeTwoLine" class-name="cell-two-line">
            </el-table-column>
            <el-table-column align="center" label="备注" prop="remarks">
            </el-table-column>
        </el-table>

        <div class="pageination">
            <el-pagination @size-change="onSizeChange" @current-change="onCurrentChange" :total="total"
                :page-size="queryForm.limit" :page-sizes="[10, 20, 30, 40, 50, 100]" :current-page="queryForm.page" background
                layout="sizes, prev, pager, next, jumper, ->, total">
            </el-pagination>
        </div>

    </div>
</template>
<script>
import { queryInStoreList } from '@/api/goods/inventory.js';
import GoodsPurchaseList from '../../GoodsAdministrative/components/GoodsPurchaseList.vue';
export default {
    data() {
        return {
            loading: false,
            total: 0, // 总条数
            tableData: [], // 表格数据
            queryForm: {
                page: 1,
                limit: 10,
            }
        }
    },
    components: {
    },
    created() {
        // 判断是否是跳转过来的
        if (this.$route.params.inNo) {
            this.queryForm.inNo = this.$route.params.inNo;
        }
        this.queryInStoreList();
    },
    computed: {
    },
    methods: {
        // 跳转采购订单详情页
        goPurchaseList(purchaseNo){
            this.$router.push({
                name: '行政货物采购',
                params: {
                    purchaseNo: purchaseNo
                }
            })
        },
        queryInStoreList(){
            this.loading = true;
            queryInStoreList(this.queryForm).then(res => {
                if (res.code === 200) {
                    this.tableData = res.data;
                    this.total = res.count;
                }
                this.loading = false;
            })
        },
        // 当每页条数变化
        onSizeChange(e) {
            this.queryForm.page = 1;
            this.queryForm.limit = e;
            this.queryInStoreList();
        },
        // 搜索
        onSearch() {
            if (this.queryForm.rqScopeArr) {
                this.queryForm.rqScope = this.queryForm.rqScopeArr.join(',');
            }else{
                this.queryForm.rqScope = '';
            }
            this.queryForm.page = 1;
            this.queryInStoreList();
        },
        // 当页码发生变化时
        onCurrentChange(e) {
            this.queryForm.page = e;
            this.queryInStoreList();
        },

    }
}
</script>
<style lang="scss" scoped>
.outer {

    .el-form-item {
        margin-right: 20px;
    }

    .pageination {
        display: flex;
        justify-content: flex-end;
        margin-top: 5px
    }

    .topSearch {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
    }

    .queryRow {
        overflow: hidden;
        display: flex;

        .queryName {
            width: 300px;
            margin-right: 10px;
        }

        .dataPicker {
            margin-right: 10px;
        }
    }

    .detailTable {
        ::v-deep .el-checkbox__input {
            &.is-checked {
                .el-checkbox__inner {
                    background-color: #409EFF;
                    border-color: #409EFF;
                }
            }
        }
    }

    .el-table {
        ::v-deep .warning-row {
            display: none;
        }
    }

    .table {

        ::v-deep .el-table__cell {
            >:empty::before {
                content: '--';
                color: gray;
            }
        }
    }
}
</style>

